import { render, staticRenderFns } from "./TabPromocodes.vue?vue&type=template&id=56967085&scoped=true"
import script from "./TabPromocodes.vue?vue&type=script&lang=js"
export * from "./TabPromocodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56967085",
  null
  
)

export default component.exports